module.exports = __webpack_public_path__ + "static/img_pledge_children_03-7cadc478a5f7f77befc80360e75abbdb.png";